<template>
    <div class="formula-cell" :class="[field.alignment, { 'with-tooltip': showTooltip }]">
        <a-tooltip :title="tooltipContent" :visible="showTooltip" @visibleChange="handleTooltipVisibility">
            <div class="cell-content" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
                <span v-if="loading" class="loading-indicator">
                    <a-icon type="loading" />
                </span>
                <template v-else>
                    <span class="value">{{ formattedValue }}</span>
                    <span class="formula-badge">
                        <i class="material-icons">functions</i>
                    </span>
                </template>
            </div>
        </a-tooltip>
    </div>
</template>

<script>
import Vue from "vue";
import { isNumber, isDate } from "lodash";
import moment from "moment";

export default Vue.extend({
    name: "FormulaCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        table: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            showTooltip: false,
        };
    },
    computed: {
        rawValue() {
            return this.record.data[this.field._id];
        },
        formattedValue() {
            if (this.rawValue === null || this.rawValue === undefined) {
                return "";
            }

            // Tarih ise, formatla
            if (this.isDateValue(this.rawValue)) {
                return moment(this.rawValue).format("DD.MM.YYYY HH:mm");
            }

            // Sayı ise, formatla
            if (isNumber(this.rawValue)) {
                return new Intl.NumberFormat("tr-TR", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 0,
                }).format(this.rawValue);
            }

            // Boolean ise, Evet/Hayır olarak göster
            if (typeof this.rawValue === "boolean") {
                return this.rawValue ? "Evet" : "Hayır";
            }

            // Diğer türdeki değerler için
            return String(this.rawValue);
        },
        tooltipContent() {
            const expression = this.field.options?.formula?.expression || "";
            const referencedFields = this.table.fields;

            // Formül ifadesini daha okunabilir hale getir
            let readableExpression = expression;
            referencedFields.forEach((field) => {
                if (field) {
                    const fieldName = field.name;
                    const regex = new RegExp(`{${field._id}}`, "g");
                    readableExpression = readableExpression.replace(regex, `{${fieldName}}`);
                }
            });

            return `Formül: ${readableExpression}
Değer: ${this.formattedValue}`;
        },
    },
    methods: {
        handleTooltipVisibility(visible) {
            this.showTooltip = visible;
        },
        findField(fieldId) {
            return this.$store.state.table.tables
                .find((t) => t._id === this.field.table)
                ?.fields.find((f) => f._id === fieldId);
        },
        isDateValue(value) {
            console.log("isDateValue value", value);
            if (!value) return false;

            // Tarih nesnesi ise
            if (value instanceof Date) return true;

            // String tarih ise kontrol et
            //must be includes / or - or :
            if (typeof value === "string") {
                if (value.includes("/") || value.includes("-") || value.includes(":")) {
                    const date = new Date(value);
                    return !isNaN(date.getTime());
                }
            }

            return false;
        },
    },
});
</script>

<style lang="scss" scoped>
.formula-cell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    cursor: default; // Read-only olduğunu göstermek için

    &.left {
        justify-content: flex-start;
    }

    &.center {
        justify-content: center;
    }

    &.right {
        justify-content: flex-end;
    }

    &.with-tooltip {
        background-color: #f0f5ff;
    }

    .cell-content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 4px 8px;
        position: relative;

        .value {
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .formula-badge {
            font-size: 12px;
            color: #1890ff;
            display: flex;
            align-items: center;
            margin-left: 6px;

            i {
                font-size: 16px;
            }
        }

        .loading-indicator {
            width: 100%;
            text-align: center;
            color: #d9d9d9;
        }
    }
}
</style>
